const requesterCompanyTypes = [
  {
    id: 'RCT00',
    title: 'Emprendedores y profesionales',
    index: 1,
    helpKey: 'RCT00H',
    color: "#ffcc00",
    colorFilterValues: {
      invert: '79',
      sepia: '28',
      saturate: '3435',
      hueRotate: '1',
      brightness: '106',
      contrast: '103'
    }
  },
  {
    id: 'RCT01',
    title: 'Start Up,  Spin Off,  NewCo, etc',
    index: 2,
    helpKey: 'RCT01H',
    color: "#ffcc00",
    colorFilterValues: {
      invert: '79',
      sepia: '28',
      saturate: '3435',
      hueRotate: '1',
      brightness: '106',
      contrast: '103'
    }
  },
  {
    id: 'RCT02',
    title: 'Grandes  Empresas Familiares',
    index: 7,
    helpKey: 'RCT02H',
    color: "#ffcc00",
    colorFilterValues: {
      invert: '79',
      sepia: '28',
      saturate: '3435',
      hueRotate: '1',
      brightness: '106',
      contrast: '103'
    }
  },
  {
    id: 'RCT03',
    title: 'Corporaciones empresariales/ Holding',
    index: 3,
    helpKey: 'RCT03H',
    color: "#ffcc00",
    colorFilterValues: {
      invert: '79',
      sepia: '28',
      saturate: '3435',
      hueRotate: '1',
      brightness: '106',
      contrast: '103'
    }
  },
  {
    id: 'RCT04',
    title: 'Empresas pequeñas',
    index: 5,
    helpKey: 'RCT04H',
    color: "#ffcc00",
    colorFilterValues: {
      invert: '79',
      sepia: '28',
      saturate: '3435',
      hueRotate: '1',
      brightness: '106',
      contrast: '103'
    }
  },
  {
    id: 'RCT05',
    title: 'Empresas Medianas',
    index: 6,
    helpKey: 'RCT05H',
    color: "#ffcc00",
    colorFilterValues: {
      invert: '79',
      sepia: '28',
      saturate: '3435',
      hueRotate: '1',
      brightness: '106',
      contrast: '103'
    }
  },
  {
    id: 'RCT06',
    title: 'Midl-Market',
    index: 8,
    helpKey: 'RCT06H',
    color: "#ffcc00",
    colorFilterValues: {
      invert: '79',
      sepia: '28',
      saturate: '3435',
      hueRotate: '1',
      brightness: '106',
      contrast: '103'
    }
  },
  {
    id: 'RCT07',
    title: 'ONG´s, Fundaciones, Organizaciones sin Lucro, etc.',
    index: 4,
    helpKey: 'RCT07H',
    color: "#ffcc00",
    colorFilterValues: {
      invert: '79',
      sepia: '28',
      saturate: '3435',
      hueRotate: '1',
      brightness: '106',
      contrast: '103'
    }
  },
  {
    id: 'RCT08',
    title: 'Instituciones Públicas.',
    index: 9,
    helpKey: 'RCT08H',
    color: "#ffcc00",
    colorFilterValues: {
      invert: '79',
      sepia: '28',
      saturate: '3435',
      hueRotate: '1',
      brightness: '106',
      contrast: '103'
    }
  },
  {
    id: 'RCT09',
    title: 'Cooperativas.',
    index: 10,
    helpKey: 'RCT09H',
    color: "#ffcc00",
    colorFilterValues: {
      invert: '79',
      sepia: '28',
      saturate: '3435',
      hueRotate: '1',
      brightness: '106',
      contrast: '103'
    }
  },
  {
    id: 'RCT11',
    title: 'Instituciones Financieras / Bancos / Compañías de seguros',
    index: 11,
    helpKey: 'RCT11H',
    color: "#ffcc00",
    colorFilterValues: {
      invert: '79',
      sepia: '28',
      saturate: '3435',
      hueRotate: '1',
      brightness: '106',
      contrast: '103'
    }
  },
  {
    id: 'RCT12',
    title: 'Compañía Offshore',
    index: 12,
    helpKey: 'RCT12H',
    color: "#ffcc00",
    colorFilterValues: {
      invert: '79',
      sepia: '28',
      saturate: '3435',
      hueRotate: '1',
      brightness: '106',
      contrast: '103'
    }
  },
  {
    id: 'RCT10',
    title: 'Otra organización no listada',
    index: 13,
    helpKey: 'RCT10H',
    color: "#ffcc00",
    colorFilterValues: {
      invert: '79',
      sepia: '28',
      saturate: '3435',
      hueRotate: '1',
      brightness: '106',
      contrast: '103'
    }
  }
]
export default requesterCompanyTypes
